module.exports = __webpack_public_path__ + "static/img/qd_type1.07bb6c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qd_type1.png
// module id = eTDt
// module chunks = 167